/* global reservations_l10n */

// To start reading this file please go to the end of the file,
// is where the entrypoint is defined.

import createCalendarURI from '../helpers/create-calendar';
import doRequestHelper from '../helpers/do-request';
import baseScrollTo from '../helpers/scroll-to';
import {
    formatTimeAMPM,
    addLeadingZero,
    parseDate,
} from '../helpers/date-utils';
import {
    parseFormData,
    prepareFormValidation,
    validateField,
} from '../helpers/form';

const $ = window.jQuery;

const doRequest = doRequestHelper(reservations_l10n.url);

let $confirmationForm;
let $availabilityForm;
let $reservationTimesContainer;
let $reservationTimesText;
// Elements in the page that should be dimmed when a request is being processed.
let $dimmableElements;
let $openTableError;
let $openTableErrorText;
let $jsReservationDetail;
let $datePicker;
let $timePicker;
const reservationData = {
    availabilityForm: null,
    availableTimes: null,
    selectedDateTime: null,
    confirmationForm: null,
    confirmationNumber: null,
};
let validateAvailabilityForm;

window.reservationData = reservationData;

function scrollTo(position, speed) {
    const realPosition = position - $('#nav').height();

    baseScrollTo(realPosition, speed);
}

/**
 * Displays or hides the error's box.
 *
 * @param {boolean|null|string} errorMsg If boolean, shows the generic error; if null, the error's box is hidden; if string, it shows that string as the error.
 */
function showError(errorMsg) {
    // Show standard error if true.
    if (errorMsg === true) {
        // eslint-disable-next-line no-param-reassign
        errorMsg = 'We’re sorry we are having trouble confirming your reservation, please try later.';
    }

    if (errorMsg === null) {
        $openTableError.removeClass('error');
        $openTableErrorText.text('');
    } else {
        // $jsReservationDetail.trigger('hide');

        $openTableError.toggleClass('error', true);
        $openTableErrorText.text(errorMsg);

        scrollTo($openTableError.offset().top, 500);
    }
}

/**
 * @param {Date} date
 */
function showNoTablesAvailableMessage(date) {
    const text = 'We’re sorry but there aren’t any tables available at that time. Please select a different time.';

    $reservationTimesText.text(text);
}

/**
 * Builds a DateTime string with the format 2020-12-31T17:15.
 *
 * @param {Date} dateObj - Date object to be parsed.
 * @returns {string}
 */
function buildDateTimeString(dateObj) {
    return [
        [
            dateObj.getFullYear(),
            addLeadingZero(dateObj.getMonth() + 1),
            addLeadingZero(dateObj.getDate()),
        ].join('-'),
        [
            addLeadingZero(dateObj.getHours()),
            addLeadingZero(dateObj.getMinutes()),
        ].join(':'),
    ].join('T');
}

/**
 * @param {Array} times
 */
function buildTimePicker(times) {
    reservationData.availableTimes = times;

    /** @var {string} - HTML with the list of buttons. */
    let liList = '';
    /** @var {boolean} - States if the time selected by the user in the dropdown is available or not. */
    let timeSelectedIsAvailable = false;
    /** @var {Date|null} - Datetime selected by the user or null if it is not parsed. */
    const dtSelected = parseDate(
        [
            reservationData.availabilityForm.date,
            reservationData.availabilityForm.time,
        ].join(' '),
    );

    if (dtSelected === false) {
        throw new Error('Invalid date-time selected.');
    }

    const dtSelectedStr = buildDateTimeString(dtSelected);

    reservationData.availableTimes.forEach(item => {
        let activeClass = '';

        if (item.id === dtSelectedStr) {
            reservationData.selectedDateTime = item.id;
            timeSelectedIsAvailable = true;
            activeClass = 'active';
        }

        liList += `<li class="item ${activeClass}">
            <button class="btn btn--outline" data-time="${item.id}">
            ${item.value}
            </button>
        </li>`;
    });

    // If the time select is available:
    if (timeSelectedIsAvailable) {
        $reservationTimesText.text(
            'Your chosen time is selected here. Please fill out additional details below.',
        );
    }

    // If the time selected is not available:
    if (!timeSelectedIsAvailable) {
        showNoTablesAvailableMessage(dtSelected);

        // $openTableError.toggleClass('error', true);
        // $jsReservationDetail.trigger('hide');
    }

    $reservationTimesContainer.html(liList);
    $jsReservationDetail.trigger('show');

    $openTableError.removeClass('error');

    scrollTo($('.js-reservation-detail').offset().top, 500);
}

function searchAvailableTimes($button) {
    // If the form is already submitting, then stop here.
    if ($availabilityForm.is('.js-disabled') === true) {
        return;
    }

    const isFormValid = validateAvailabilityForm();

    if (!isFormValid) {
        return;
    }

    // Hide any previous error message if the form is submitted.
    showError(null);

    $dimmableElements.addClass('js-disabled');

    reservationData.confirmationNumber = null;
    reservationData.availableTimes = null;
    reservationData.selectedDateTime = null;
    reservationData.availabilityForm = parseFormData($availabilityForm);

    $reservationTimesContainer.find('.active').removeClass('active');

    $openTableError.removeClass('error');

    const isButtom = typeof $button !== 'undefined';

    doRequest(
        'GET',
        'reservations/get_available_times',
        reservationData.availabilityForm,
    )
        .then(response => {
            if (response.error && isButtom) {
                $button.parent().remove();
                showNoTablesAvailableMessage(parseDate($button.data('time')));
                return;
            }

            $reservationTimesContainer.html('');
            $reservationTimesText.html('');

            if (response.error) {
                showError(response.error);

                $jsReservationDetail.trigger('hide');

                return;
            }

            buildTimePicker(response.data.times);
        })
        .fail(() => {
            showError(true);
        })
        .always(() => {
            $dimmableElements.removeClass('js-disabled');
        });
}

/**
 * Handles the first block, where the user have to pick the restaurant, date-time
 * and party-size to check availability.
 */
function handleSearchAvailableTimes() {
    /**
     * Builds the time picker in the SearchAvailability's form.
     */
    function populateTimeField() {
        $timePicker
            .html('<option value="">Select a valid date first</option>')
            .prop('disabled', true);

        const dateSelected = parseDate($datePicker.val());
        const currDate = new Date();

        currDate.setHours(0, 0, 0, 0);

        if (dateSelected !== false) {
            dateSelected.setHours(0, 0, 0, 0);
        }

        const isDateValid = validateField($datePicker, () => {
            return (
                dateSelected !== false &&
                dateSelected.getTime() >= currDate.getTime()
            );
        });

        if (!isDateValid) {
            return;
        }

        dateSelected.setHours(7, 0, 0, 0);

        let optionsHtml = '<option value="">Pick a time</option>';
        const fieldDefValue = $timePicker.data('value') || '';

        for (let index = 1; index < 68; index += 1) {
            const dateStr24 = [
                addLeadingZero(dateSelected.getHours()),
                addLeadingZero(dateSelected.getMinutes()),
            ].join(':');
            const dateStr12 = formatTimeAMPM(dateSelected);
            let disabledAttr = '';
            let selectedAttr = '';

            if (dateSelected.getTime() <= currDate.getTime()) {
                disabledAttr = 'disabled';
            }

            if (fieldDefValue === dateStr24) {
                selectedAttr = 'selected';
            }

            optionsHtml += `<option ${disabledAttr} ${selectedAttr} value="${dateStr24}">${dateStr12}</option>`;

            dateSelected.setTime(dateSelected.getTime() + 60 * 15 * 1000);
        }

        $timePicker.html(optionsHtml).prop('disabled', false);
    }

    function populateDateField() {
        if ($datePicker.val() !== '') {
            return;
        }

        const currDate = new Date();

        const dateString = [
            addLeadingZero(currDate.getMonth() + 1),
            addLeadingZero(currDate.getDate()),
            currDate.getFullYear(),
        ].join('-');

        $datePicker.val(dateString);
    }

    /**
     * Build the fields for date and time selection.
     */
    function buildDateTimeFields() {
        $datePicker.datepicker({
            dateFormat: 'mm-dd-yy',
            minDate: 0,
            autoSize: true,
            beforeShow: (input, inst) => {
                setTimeout(() => {
                    inst.dpDiv.css({
                        top: $('.hasDatepicker').offset().top,
                        left: $('.hasDatepicker').offset().left,
                    });
                }, 0);
            },
        });

        populateDateField();
        populateTimeField();

        $datePicker.on('change', () => {
            const value = $datePicker.val();

            // The field should have 10 digits.
            if (value.length !== 10) {
                const parts = value.split('-');
                const fixedValue = [
                    parts[0].padStart(2, '0'),
                    parts[1].padStart(2, '0'),
                    parts[2],
                ].join('-');

                $datePicker.val(fixedValue);
            }

            populateTimeField();
        });
    }

    function getFilledFields() {
        return $availabilityForm
            .serializeArray()
            .filter(item => item.value !== '');
    }

    buildDateTimeFields();

    // When the form is submitted:
    $availabilityForm.on('submit', evt => {
        evt.preventDefault();

        // If the user is not in the reservation's page, then
        // the browser is redirected to that page including the parameters
        // selected by the user.
        if ($confirmationForm.length === 0) {
            window.location.href = `/reservations?${$availabilityForm.serialize()}`;
            return;
        }

        searchAvailableTimes();
    });

    // IF the user comes to the reservation page with the parameters filled,
    // then the checkAvailability is fired.
    // This could happen when the user is in a page with checkAvailability's form.
    if ($confirmationForm.length === 1) {
        const filledFields = getFilledFields();

        // There are 4 fields that should be filled to fire the form.
        if (filledFields.length === 4) {
            $availabilityForm.trigger('submit');
        }
    }
}

/**
 * Handles the second (blue) block, where the user have to pick the time using
 * the buttons displayed.
 */
function handleAvailableTimesPicker() {
    // When one of the blocks of time is clicked.
    $reservationTimesContainer.on('click', evt => {
        evt.preventDefault();
        $reservationTimesContainer.find('.active').removeClass('active');
        const $button = $(evt.target);

        if (
            !$button.is('button') ||
            $button.is('.btn--disabled') ||
            $button.parent().is('.active')
        ) {
            return;
        }

        const btnDateTime = $button.data('time');
        const [, confirmedTime] = btnDateTime.split('T');

        $availabilityForm
            .find('[name=location]')
            .val(reservationData.availabilityForm.location);
        $availabilityForm
            .find('[name=date]')
            .val(reservationData.availabilityForm.date)
            .trigger('change'); // This is fired because the time's field is re-built based on this field every time it's changed.
        $availabilityForm.find('[name=time]').val(confirmedTime);
        $availabilityForm
            .find('[name=party_size]')
            .val(reservationData.availabilityForm.party_size);

        searchAvailableTimes($button);
    });
}

/**
 * Handles the confirmation form where the user have to put the information to
 * confirm the reservation.
 */
function handleConfirmationForm() {
    const validate = prepareFormValidation($confirmationForm);

    // When the confirmation form is submitted.
    $confirmationForm.on('submit', evt => {
        evt.preventDefault();

        const isDisabled = $confirmationForm.is('.js-disabled');
        const isInvalid = !validate;

        if (isDisabled || isInvalid) {
            return;
        }

        // If the time has not been selected, the user is redirected to the block where it can be selected.
        if (reservationData.selectedDateTime === null) {
            scrollTo($jsReservationDetail.offset().top, 500);
            return;
        }

        $dimmableElements.toggleClass('js-disabled', true);

        reservationData.confirmationForm = parseFormData($confirmationForm);

        const data = reservationData.confirmationForm;

        data.location = reservationData.availabilityForm.location;
        data.party_size = reservationData.availabilityForm.party_size;
        data.date_time = reservationData.selectedDateTime;

        $openTableError.removeClass('error');

        doRequest('POST', 'reservations/reserve_table', data)
            .then(response => {
                if (response.error === '_NO_TABLES_AVAILABLE_') {
                    showNoTablesAvailableMessage();
                    scrollTo($('.js-reservation-detail').offset().top, 500);
                    return;
                }

                if (response.error) {
                    showError(response.error);
                    return;
                }

                const { data: resData } = response;

                reservationData.confirmationNumber =
                    resData.confirmation_number;

                const $jsConfirmationMsg = $('#js-confirmation-msg');
                const timeStr = formatTimeAMPM(
                    parseDate(reservationData.selectedDateTime),
                );

                // SHow confirmation message.
                $jsConfirmationMsg
                    .find('.reservation-date')
                    .text(reservationData.availabilityForm.date);
                $jsConfirmationMsg
                    .find('.reservation-time')
                    .text(
                        `${timeStr} | Table for ${
                            reservationData.availabilityForm.party_size
                        }`,
                    );
                $jsConfirmationMsg
                    .find('.reservation-id')
                    .text(
                        `Confirmation ID # ${
                            reservationData.confirmationNumber
                        }`,
                    );

                const contactInfo = {
                    name: [
                        reservationData.confirmationForm.first_name,
                        reservationData.confirmationForm.last_name,
                    ]
                        .join(' ')
                        .trim(),
                    phone: reservationData.confirmationForm.phone,
                    email: reservationData.confirmationForm.email,
                };

                $jsConfirmationMsg
                    .find('.location-contact')
                    .text(contactInfo.name);
                $jsConfirmationMsg
                    .find('.location-contact-phone')
                    .text(contactInfo.phone);
                $jsConfirmationMsg
                    .find('.location-contact-email')
                    .text(contactInfo.email);
                $jsConfirmationMsg
                    .find('.yelp-tag')
                    .html(
                        '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=5hq0nsj&ct=0:jg9zgxu&fmt=3"/>',
                    );

                const locField = $availabilityForm.find(
                    '[name=location] :selected',
                );
                const locData = locField.data();

                $jsConfirmationMsg.find('.location-name').text(locField.text());
                $jsConfirmationMsg
                    .find('.location-address')
                    .text(locData.address);
                $jsConfirmationMsg.find('.location-phone').text(locData.phone);

                $jsConfirmationMsg.find('.btn-add-to-calendar').attr(
                    'href',
                    createCalendarURI({
                        startTime: parseDate(reservationData.selectedDateTime),
                        summary: 'Dinner at Fogo de Chao',
                        location: locData.address,
                        contactEmail: contactInfo.email,
                    }),
                );

                $jsConfirmationMsg
                    .find('.location-map-link')
                    .attr(
                        'href',
                        `https://maps.google.com/?daddr=${locData.lat},${
                            locData.lng
                        }&ll=`,
                    );

                $('.js-reservation-form').hide();
                $jsConfirmationMsg.show();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'reservation_success'
                });
            })
            .fail(() => {
                showError(true);
            })
            .always(() => {
                $dimmableElements.removeClass('js-disabled');
            });
    });
}

/**
 * Initialize variables needed in the page.
 */
function bootstrap() {
    validateAvailabilityForm = prepareFormValidation($availabilityForm);

    $confirmationForm = $('#js-reserve-table-form');

    $openTableError = $('.open-table-error');
    $openTableErrorText = $('.error-message__text', $openTableError);

    $reservationTimesContainer = $('.reservation-times__buttons');
    $reservationTimesText = $('.reservation-times__text');

    $dimmableElements = $(
        '#js-reserve-table-form, .reservation, .reservation-times',
    );

    $jsReservationDetail = $('.js-reservation-detail');

    $jsReservationDetail
        .on('show', () => {
            $jsReservationDetail.toggleClass('add-reservation', true);
        })
        .on('hide', () => {
            $jsReservationDetail.toggleClass('add-reservation', false);
        });

    $datePicker = $('#js-date-picker');
    $timePicker = $('#js-time-picker');
}

$(document).ready(() => {
    $availabilityForm = $('.reservation');

    // Code below does not need to execute if the user is not
    // in the reservation page.
    if ($availabilityForm.length === 0) {
        return;
    }

    bootstrap();

    // Entrypoint.
    handleAvailableTimesPicker();
    handleConfirmationForm();
    handleSearchAvailableTimes();

    if($availabilityForm) {
        const isNumericInput = (event) => {
            const key = event.keyCode;
            return ((key >= 48 && key <= 57) || // Allow number line
                (key >= 96 && key <= 105) // Allow number pad
            );
        };

        const isModifierKey = (event) => {
            const key = event.keyCode;
            return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
                (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
                (key > 36 && key < 41) || // Allow left, up, right, down
                (
                    // Allow Ctrl/Command + A,C,V,X,Z
                    (event.ctrlKey === true || event.metaKey === true) &&
                    (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
                )
        };

        const enforceFormat = (event) => {
            // Input must be of a valid number format or a modifier key, and not longer than ten digits
            if(!isNumericInput(event) && !isModifierKey(event)){
                event.preventDefault();
            }
        };

        const formatToPhone = (event) => {
            if(isModifierKey(event)) {return;}

            // I am lazy and don't like to type things more than once
            const target = event.target;
            const input = event.target.value.replace(/\D/g,'').substring(0,10); // First ten digits of input only
            const zip = input.substring(0,3);
            const middle = input.substring(3,6);
            const last = input.substring(6,10);

            if(input.length > 6){target.value = `(${zip})${middle}${last}`;}
            else if(input.length > 3){target.value = `(${zip})${middle}`;}
            else if(input.length > 0){target.value = `(${zip}`;}
        };

        const inputElement = document.getElementById('phone');
        console.log(inputElement);
        inputElement.addEventListener('keydown',enforceFormat);
        inputElement.addEventListener('keyup',formatToPhone);
    }
});
